import React, { useEffect, useState } from "react";
export function StoreTypologyFilter({ StoreTypologyFiltersVariant, allStores, configuration, filter, setFilter, }) {
    const [storeTypes, setStoreTypes] = useState([]);
    useEffect(() => {
        const types = allStores.flatMap((s) => s.storeTypes);
        setStoreTypes([...new Set(types)]);
    }, [allStores]);
    return (React.createElement(StoreTypologyFiltersVariant, { configuration: configuration, filter: filter, storeTypes: storeTypes, setFilter: setFilter }));
}
